import { render, staticRenderFns } from "./WordForm.vue?vue&type=template&id=4e8c140c&scoped=true&"
import script from "./WordForm.vue?vue&type=script&lang=js&"
export * from "./WordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8c140c",
  null
  
)

export default component.exports